import { Breadcrumb, Event } from '@sentry/react';

const TOKEN_IN_PATH = /(\/(?:utvardering|rating|erfaDoc)\/)[^/?#\s"']+/gi;

const scrub = <T>(value: T): T =>
  typeof value === 'string' ? (value.replace(TOKEN_IN_PATH, '$1[token]') as unknown as T) : value;

const scrubValues = <T extends Record<string, unknown>>(values: T): T =>
  Object.fromEntries(Object.entries(values).map(([key, value]) => [key, scrub(value)])) as T;

const scrubBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => ({
  ...breadcrumb,
  ...(breadcrumb.message !== undefined && { message: scrub(breadcrumb.message) }),
  ...(breadcrumb.data && { data: scrubValues(breadcrumb.data) }),
});

export const scrubEvaluationToken = (event: Event): Event => ({
  ...event,
  ...(event.request && {
    request: {
      ...event.request,
      ...(event.request.url !== undefined && { url: scrub(event.request.url) }),
      ...(event.request.headers && { headers: scrubValues(event.request.headers) }),
    },
  }),
  ...(event.breadcrumbs && { breadcrumbs: event.breadcrumbs.map(scrubBreadcrumb) }),
});
